import { render, staticRenderFns } from "./BaeSystemsReportsList.vue?vue&type=template&id=b66c4bc4&"
import script from "./BaeSystemsReportsList.vue?vue&type=script&lang=js&"
export * from "./BaeSystemsReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports